import { useEffect, useState } from "react"
import {
  ConsentState,
  getConsent,
  hasGlobalPrivacyControl,
  hasStoredConsent,
  setConsent,
  subscribeToConsent,
} from "../utils/consent"

export default function useConsent() {
  const [consent, setConsentState] = useState<ConsentState>(getConsent)
  const [hasChosen, setHasChosen] = useState<boolean>(hasStoredConsent)

  useEffect(
    () =>
      subscribeToConsent((next) => {
        setConsentState(next)
        setHasChosen(true)
      }),
    []
  )

  return {
    consent,
    hasChosen,
    gpc: hasGlobalPrivacyControl(),
    setConsent,
  }
}
